<template>
  <div class="error-page">
    <div class="error-code">4<span>0</span>3</div>
    <div class="error-desc">啊哦~ 你没有权限访问该页面哦</div>
    <div class="error-handle">
      <router-link to="/">
        <el-button type="primary" size="large">返回首页</el-button>
      </router-link>
      <!-- <el-button class="error-btn" type="primary" size="large" @click="goBack">返回上一页</el-button> -->
      <el-button class="error-btn" type="primary" size="large" @click="apply"
        >申请账号</el-button
      >
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="70%"
        :modal="false"
        center
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="employeeId">
            <el-input
              v-model="form.employeeId"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="companyCode">
            <el-input
              v-model="form.companyCode"
              placeholder="请输入公司代码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="sub">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        employeeId: "",
        companyCode: "",
      },
      rules: {
        employeeId: [
          { required: true, message: "请输入工号", trigger: "blur" },
        ],
        companyCode: [
          { required: true, message: "请输入公司代码", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    dialogVisible(visi) {
      if (visi) {
        this.$refs.form && this.$refs.form.resetFields();
      }
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    apply() {
      this.dialogVisible = true;
    },
    async sub() {
      let vaild = this.$refs.form.validate();
      if (!vaild) {
        return;
      }
      const { employeeId, companyCode } = this.form;
      const res = await this.$api.createUser({
        accountId: employeeId,
        companyCode,
        wxId: this.$route.query.wxId,
      });
      if (res.code == 200) {
        this.$router.push({
          path: "/RMS/H5",
          query: { ...this.$route.query },
        });
      }
    },
  },
};
</script>


<style scoped lang="less">
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #f02d2d;
}
.error-code span {
  color: #00a854;
}
.error-desc {
  font-size: 30px;
  color: #777;
}
.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}
.error-btn {
  margin-left: 100px;
}
@media (max-width: 768px) {
  .error-page {
    padding: 0 20px;
  }
  .error-code {
    font-size: 100px;
  }
  .error-desc {
    font-size: 16px;
  }
  .error-btn {
    margin-left: 20px;
  }
}

/deep/.el-dialog--center .el-dialog__body {
  padding-bottom: 0;
}
</style>
